import { font } from '@chegg-ui/theme'
import styled, { css } from 'styled-components'

const primaryThemeColor = css`
  ${({ theme }) => theme.Colors.primaryColor}
`

export const Container = styled.div`
  margin-top: 16px;
  max-height: calc(100% - 150px); /* size of the h1 title (accounts for wrapping) */
  overflow: scroll;
  padding-top: 16px;

  @media (max-width: 1200px) {
    max-height: calc(100% - 190px); /* size of the h1 title (accounts for wrapping) */
  }

  @media (max-width: 600px) {
    max-height: calc(100% - 140px); /* size of the h1 title (accounts for wrapping) */
  }

  @media (max-width: 400px) {
    max-height: calc(100% - 230px); /* size of the h1 title (accounts for wrapping) */
  }
`

export const WritingFormsWrapper = styled.div`
  .wt-writing-forms-container > h3:first-of-type {
    display: none;
  }
  input[type='checkbox']:checked + svg,
  input[type='checkbox']:checked:hover + svg {
    > g > rect {
      fill: ${primaryThemeColor};
      stroke: ${primaryThemeColor};
    }
  }
  input[type='checkbox']:not(:disabled):hover + svg {
    > g > rect {
      stroke: ${primaryThemeColor};
    }
  }
  /* overriding colors for site specific theme */
  input[type='text'],
  textarea {
    &:focus,
    &:active {
      border-color: ${primaryThemeColor};
      box-shadow: none;
    }
  }

  input[type='radio']:checked + svg,
  input[type='radio']:checked:hover + svg {
    // radio button icon
    > g > circle:first-of-type {
      //outer circle
      stroke: ${primaryThemeColor};
    }
    > g > circle:nth-of-type(2) {
      //inner circle
      fill: ${primaryThemeColor};
    }
  }

  button[data-test='create-citation-button-form'],
  button[data-test='update-citation-button-form'] {
    border-color: ${primaryThemeColor};
    background: ${primaryThemeColor};

    &:active,
    &:hover {
      border-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor23};
      background-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor23};
    }
  }

  li[role='presentation'] > a[role='tab']::after {
    //tab border
    background-color: ${primaryThemeColor};
  }

  div[role='group'] {
    & > h3 {
      // group headings
      font-weight: ${font.weight.bold};
    }
  }
`
